import { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskFiles } from '../../../../../redux/tasks/taskEntities/selectors';
import { deleteTaskFileAction, getTaskAction } from '../../../../../redux/tasks/actions';
import TaskFileHolder from '../../../organisms/TaskFileHolder';

const TaskDetailsFileHolder = ({ isModal, taskFiles, taskId }) => {
  const dispatch = useDispatch();
  const params = useParams();

  const delAttachment = useCallback((fileId) => {
    dispatch(
      deleteTaskFileAction(taskId || params.taskid, fileId, () =>
        dispatch(getTaskAction(taskId || params.taskid)),
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.taskid, taskId]);

  return isModal && taskFiles?.length > 0 ? (
    <div className="flex align-center col-span-7">
      <TaskFileHolder
        files={taskFiles || []}
        taskId={taskId}
        delAttachment={delAttachment}
      />
    </div>
  ) : null;
}

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
  taskFiles: getOpenedTaskFiles(state),
});

export default connect(mapStateToProps)(TaskDetailsFileHolder);
